module.exports = __webpack_public_path__ + "img/server2.9f92731.png";